import { render, staticRenderFns } from "./ServiceCategoryTab.vue?vue&type=template&id=42e87906&scoped=true&"
import script from "./ServiceCategoryTab.vue?vue&type=script&lang=ts&"
export * from "./ServiceCategoryTab.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceCategoryTab.vue?vue&type=style&index=0&id=42e87906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e87906",
  null
  
)

export default component.exports